var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { v4 } from 'uuid';
import { WorldEngine, } from '../../../proto/ai/inworld/engine/world-engine.pb';
import { CLIENT_ID } from '../../common/constants';
import { PbService } from './pb.service';
var version = require('../../../package.json').version;
var INWORLD_USER_ID = 'inworldUserId';
var WorldEngineService = /** @class */ (function (_super) {
    __extends(WorldEngineService, _super);
    function WorldEngineService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WorldEngineService.prototype.loadScene = function (props) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var req, finalReq, res;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        req = this.buildRequest(props);
                        finalReq = (_c = (_b = (_a = props.extension) === null || _a === void 0 ? void 0 : _a.beforeLoadScene) === null || _b === void 0 ? void 0 : _b.call(_a, req)) !== null && _c !== void 0 ? _c : req;
                        return [4 /*yield*/, this.request(props.config, props.session, WorldEngine.LoadScene, finalReq)];
                    case 1:
                        res = _f.sent();
                        (_e = (_d = props.extension) === null || _d === void 0 ? void 0 : _d.afterLoadScene) === null || _e === void 0 ? void 0 : _e.call(_d, res);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    WorldEngineService.prototype.buildRequest = function (props) {
        var config = props.config, name = props.name, _a = props.sessionContinuation, _b = _a === void 0 ? {} : _a, previousDialog = _b.previousDialog, previousState = _b.previousState, _c = props.user, user = _c === void 0 ? {} : _c;
        var id = user.id, fullName = user.fullName, profile = user.profile;
        return __assign(__assign({ client: this.getClient(props), name: name, user: __assign({ id: id ? id : this.getUserId() }, (fullName && { name: fullName })), capabilities: config.capabilities }, ((profile === null || profile === void 0 ? void 0 : profile.fields.length) && {
            userSettings: {
                playerProfile: {
                    fields: profile.fields.map(function (_a) {
                        var fieldId = _a.id, fieldValue = _a.value;
                        return ({ fieldId: fieldId, fieldValue: fieldValue });
                    }),
                },
            },
        })), ((previousDialog || previousState) && {
            sessionContinuation: __assign(__assign({}, (previousDialog && { previousDialog: previousDialog.toProto() })), (previousState && {
                previousState: previousState,
            })),
        }));
    };
    WorldEngineService.prototype.getClient = function (props) {
        var _a;
        var description = [CLIENT_ID, version, navigator.userAgent];
        if ((_a = props.client) === null || _a === void 0 ? void 0 : _a.id) {
            description.push(props.client.id);
        }
        return {
            id: CLIENT_ID,
            version: version,
            description: description.join('; '),
        };
    };
    WorldEngineService.prototype.getUserId = function () {
        var id = localStorage.getItem(INWORLD_USER_ID);
        if (!id) {
            id = v4();
            localStorage.setItem(INWORLD_USER_ID, id);
        }
        return id;
    };
    return WorldEngineService;
}(PbService));
export { WorldEngineService };
